import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpBackend, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class ListService {

	private httpClient: HttpClient;

	constructor( handler: HttpBackend
	) { 
		this.httpClient = new HttpClient(handler);
	}

	getList(): Observable<any> {
		return this.httpClient.get<any>(`${environment.externalResource}/dags`);
	}
}